module.exports = __webpack_public_path__ + "static/media/03-2-recption-.30f15d65.webp";